var map = {
	"./paperpaper.png": [
		50779,
		779
	],
	"./paperrock.png": [
		20942,
		942
	],
	"./paperscissors.png": [
		25076,
		76
	],
	"./rockpaper.png": [
		32416,
		416
	],
	"./rockrock.png": [
		16055,
		55
	],
	"./rockscissors.png": [
		69473,
		473
	],
	"./scissorspaper.png": [
		20554,
		554
	],
	"./scissorsrock.png": [
		47593,
		593
	],
	"./scissorsscissors.png": [
		53335,
		335
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 57868;
module.exports = webpackAsyncContext;